(ns practitest.frontend.components2.icons-list
  (:require [practitest.frontend.components.icons :as icons]
            [reagent.core :as reagent]))

;;;; AUTOGENERATED, DO NOT EDIT, see `scripts/icons.clj`

(def exported-icons
  #js { 
  :ExclamationCircle (reagent/reactify-component icons/exclamation-circle)
  :MuxArrowLeft (reagent/reactify-component icons/mux-arrow-left)
  :MuxArrowRight3 (reagent/reactify-component icons/mux-arrow-right3)
  :MuxAutoFilter (reagent/reactify-component icons/mux-auto-filter)
  :MuxChevronDown2 (reagent/reactify-component icons/mux-chevron-down2)
  :MuxChevronRight (reagent/reactify-component icons/mux-chevron-right)
  :MuxChevronUp2 (reagent/reactify-component icons/mux-chevron-up2)
  :MuxCopy (reagent/reactify-component icons/mux-copy)
  :MuxDrag (reagent/reactify-component icons/mux-drag)
  :MuxDragHandle2 (reagent/reactify-component icons/mux-drag-handle2)
  :MuxExport (reagent/reactify-component icons/mux-export)
  :MuxFavorite (reagent/reactify-component icons/mux-favorite)
  :MuxGoTo (reagent/reactify-component icons/mux-go-to)
  :MuxInfoCircle (reagent/reactify-component icons/mux-info-circle)
  :MuxInfoRedCircle (reagent/reactify-component icons/mux-info-red-circle)
  :MuxPencil (reagent/reactify-component icons/mux-pencil)
  :MuxPencilRename (reagent/reactify-component icons/mux-pencil-rename)
  :MuxPlusCircle (reagent/reactify-component icons/mux-plus-circle)
  :MuxRegPlus (reagent/reactify-component icons/mux-reg-plus)
  :MuxSetting (reagent/reactify-component icons/mux-setting)
  :MuxTabFilter (reagent/reactify-component icons/mux-tab-filter)
  :MuxTabFolder (reagent/reactify-component icons/mux-tab-folder)
  :MuxToggle (reagent/reactify-component icons/mux-toggle)
  :MuxToggle2 (reagent/reactify-component icons/mux-toggle2)
  :MuxTrash (reagent/reactify-component icons/mux-trash)
  :MuxX (reagent/reactify-component icons/mux-x)
 })
